

















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import EventsList from '@/components/EventsList.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import {TableHeaders, ITableHeaders} from '@/interfaces/components-data';
import {
    Hints,
    SelectBox,
    SelectMarket,
    TaskInfoCalc
} from '@/interfaces/global-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import Toast from '@/mixins/toast';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import LocalData from '@/mixins/local-data';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import Card from '@/components/UI/Card.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue';
import DatePicker from '@/components/UI/DatePicker.vue';
import '@/extensions';

import {
    categoryStrategiesSet,
    ChangesPrices,
    CompetitorsPriceStrategies,
    DetailReportsPricesAndCodes,
    eventChangingTypeType,
    eventPeriodicityType,
    EventsCalcParams,
    eventTypeLoadType, eventTypeOptions,
    FtpDownloadProgress,
    GetTaskInfo,
    InternalCodesWithCorrPrices, isTaskInBackgroundGeneratableTypesAndStatuses,
    LoadEventChangingType,
    LoadEventPeriods,
    LoadEventType, LoadEventTypeLabels, LoadEventTypeValues,
    PackageParamsInDetailReportFilters,
    ReportDetailColumnsForAddOrDelete,
    ReportDetailFieldsView,
    ReportDetailParams,
    ReportDetailSegments, RequestEventList,
    ResultTableDetailReports, ResultTableDetails,
    ResultTableHeaders,
    SalesMonitorResultTableHeaders,
    ScheduleCalcColumns,
    SmallEventFilter, SmallEventFilterTree,
    SortingField,
    TaskAndFile,
    TaskData,
    TaskIdToInternalCode, TaskInfoFilterType, TaskNoteDTO, TaskStatus,
    TaskType,
    taskTypesRequiresConfirmation,
    TaskHeadersAndKeyIndicatorsParams,
} from '@/interfaces/server-data';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import {BModal, BTabs} from 'bootstrap-vue';
import moment from 'moment';
import dayjs from 'dayjs';
import IconButton from "@/components/UI/IconButton.vue";
import SalesListGanttDiagram from "@/pages/Sales/SalesTabs/SalesListTab/SalesListGanttDiagram.vue";
import SalesApi from "@/pages/Sales/SalesApi";
import {ISale} from "@/pages/Sales/data";


@Component({
    components: {
        IconButton,
        DatePicker,
        MultiSelect,
        MarketSelect,
        vSelect,
        SideToolbar,
        EventsList,
        LocalData,
        CollapseCard,
        Card,
        SalesListGanttDiagram,
    },
    methods: {
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') {
                    if (!item.activeProduct) {
                        return 'table-primary strikethroughRow'
                    } else {
                        return 'table-primary';
                    }
                }
                if (item.resultType === 'COMPETITOR') {
                    if (!item.activeProduct) {
                        return 'table-danger strikethroughRow'
                    } else {
                        return 'table-danger';
                    }
                }
                if (!item.activeProduct) {
                    return 'strikethroughRow'
                }
                if (item.eventTrigger) {
                    return 'table eventTriggerColor'
                }
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },

        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },

        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD/MM/YYYY');
            }
        },
        truncate: (value: any, length: any) => {
            if (value.length > length) {
                return value.substring(0, length) + '...';
            }
            return value;
        },
    },
})

export default class SalesMonitor extends Mixins(LocalData, Toast, Http) {
    @Prop() readonly taskData: TaskAndFile | null = null;
    @Prop() readonly selectMarketProp?: SelectMarket | null = null;
    @Prop() readonly salesApi: SalesApi = new SalesApi({parent: this});

    salesMonitorData: any = {};
    dataCardsKey: number = 0;
    tableData: SalesMonitorResultTableHeaders[] = [];
    pagination: any = {
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
    }
    priorityResponseLevel: number = 0;
    ignorePrevResponse: boolean = false;
    isTableLoading: boolean = false;
    isApplyRangeBtnLoading: boolean = false;
    isRangeNotSelected: boolean = false;
    isApplyFiltersBtnLoading: boolean = false;
    incorrectPeriodErrorText: string = '';
    taskToView: TaskAndFile | null = null;
    showPackageParamsRegularModule: boolean = false;
    showPackageParamsPromoModule: boolean = false;
    timeout: number = 1000;
    dateRange: string[] = this.getDateRange() ? JSON.parse(this.getDateRange()) : [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')];
    marginalErrorText = '';
    marginalSkuErrorText = '';
    findAutomaticallyPriceSegments: boolean = false;
    countPriceSegments: number = 1;
    showDataRange: boolean = false;
    httpExecutor: HttpExecutor = new HttpExecutor();
    showDeleteSingleReportModal: boolean = false;
    taskIdForDelete: number = -1;
    subTaskIdForSendToFTP: number = -1;
    detailUserFields: ReportDetailFieldsView[] = [];
    detailColumnsListForAddFields: ReportDetailFieldsView[] = []
    detailColumnsListForDeleteFields: ReportDetailFieldsView[] = []
    isDownloadAllFiltersName: boolean = false
    showSendToFTPReportModal: boolean = false;
    showRegularColumnsModal: boolean = false;
    showPromoColumnsModal: boolean = false;
    showSendToFTPSubTaskReportModal: boolean = false;
    resultTableHeadersPerPage: number = 20;
    resultDetailReportPerPage: number = 20;
    detailTableIdName: string = 'resultDetailReport';
    resultTableHeaderCurrentPage: number = 1;
    downloadLastExcelDetailByFilters: boolean = false;
    skuListCurrentPage: number = 1;
    downloadLastExcelHeaderByFilters: boolean = false;
    resultTableHeaders: ResultTableHeaders[] = [];
    resultGeneralSubtasksTableHeaders: ResultTableHeaders[] = [];
    resultTableDetailReports: ResultTableDetailReports[] = [];
    showPromoBlock: boolean = true;
    isPromo: boolean = false;
    isPackageOrScheduleReport: boolean = false;
    isPackagePromoReport: boolean = false;
    isGeneralRegularPackage: boolean = false;
    detailTableSkuFilter: string = '';
    refreshHeaderTableId = -1;
    refreshDetailTableId = -1;
    onDropdownClosed: Function | null = null;
    dropDownOpen = false;
    activeTabKey: string = "changeCalculations";
    currentTabStatus: string = "DEFAULT";
    sortByTaskId: number = -1;
    sortByStatus: number = -1;
    sortByGroupName: number = -1;
    sortByCategoryName: number = -1;
    sortBySubCategoryName: number = -1;
    sortByFormatName: number = -1;
    sortByRegionName: number = -1;
    sortByClusterName: number = -1;
    sortByProductSegmentName: number = -1;
    sortByInternalCode: number = -1;
    sortBySkuName: number = -1;
    sortByEventTrigger: number = -1;
    sortByKvi: number = -1;
    sortByCtm: number = -1;
    sortByCtmBrand: number = -1;
    sortByCtmPriceGap: number = -1;
    sortByMinRetailPrice: number = -1;
    sortByMaxRetailPrice: number = -1;
    sortByKeyProduct1: number = -1;
    sortByKeyProduct2: number = -1;
    sortByRecipeAttribute: number = -1;
    sortByTreatmentAttribute: number = -1;
    sortByVitalMedicine: number = -1;
    sortByProducerPrice: number = -1;
    sortByExtraChargePc: number = -1;
    sortByRegistrationPrice: number = -1;
    sortBySegment: number = -1;
    sortBySkuLine: number = -1;
    sortByPurchasePrice: number = -1;
    sortByPromoPurchasePrice: number = -1;
    sortByAvgRegularPrice: number = -1;
    sortByAvgCashPrice: number = -1;
    sortByAvgCheckPrice: number = -1;
    sortByRegularPrice: number = -1;
    sortByMarginLastPrice: number = -1;
    sortByMinCompetitorPrice: number = -1;
    sortByMinCompetitorName: number = -1;
    sortByMaxCompetitorPrice: number = -1;
    sortByMaxCompetitorName: number = -1;
    sortByAvgCompetitorPrice: number = -1;
    sortByLastCompetitorPrice: number = -1;
    sortByMinPromoCompetitorPrice: number = -1;
    sortByMinPromoCompetitorName: number = -1;
    sortByMaxPromoCompetitorPrice: number = -1;
    sortByMaxPromoCompetitorName: number = -1;
    sortByMedianPromoCompetitorPrice: number = -1;
    sortByLastPromoCompetitorPrice: number = -1;
    sortByPi: number = -1;
    sortByActualSales: number = -1;
    sortByActualRevenue: number = -1;
    sortByActualMargin: number = -1;
    sortByActualMarginPercent: number = -1;
    sortByComparableSales: number = -1;
    sortByComparableRevenue: number = -1;
    sortByComparableMargin: number = -1;
    sortByComparableMarginPc: number = -1;
    sortByNewPrice: number = -1;
    sortByNewPromoPrice: number = -1;
    sortByCorrectedPromoPrice: number = -1;
    sortByCorrectedRegularPrice: number = -1;
    sortByNewMarginPc: number = -1;
    sortByNewPI: number = -1;
    sortByDeltaDiffPrice: number = -1;
    sortByPriceDiffPc: number = -1;
    sortByMarginDiff: number = -1;
    sortByChangedPI: number = -1;
    sortByDiscountDepth: number = -1;
    sortByDiscountDuration: number = -1;
    sortByExitSegment: number = -1;
    sortByCoeffElasticity: number = -1;
    sortByPromoCoeffElasticity: number = -1;
    sortBySalesForecast: number = -1;
    sortByRevenueForecast: number = -1;
    sortByMarginForecast: number = -1;
    sortByMarginForecastPc: number = -1;
    sortByChangeSales: number = -1;
    sortByChangeRevenue: number = -1;
    sortByChangeMargin: number = -1;
    sortBySalesDiffPc: number = -1;
    sortByRevenueDiffPc: number = -1;
    sortByMarginDiffPc: number = -1;
    sortByMarginDiffSecond: number = -1;
    sortBySalesForecastByRegularPrice: number = -1;
    sortByRevenueForecastByRegularPrice: number = -1;
    sortByMarginForecastByRegularPrice: number = -1;
    sortByMarginForecastByRegularPricePc: number = -1;
    sortByChangeSalesByRegularPrice: number = -1;
    sortByChangeRevenueByRegularPrice: number = -1;
    sortByChangeMarginByRegularPrice: number = -1;
    sortBySalesDiffPcByRegularPrice: number = -1;
    sortByRevenueDiffPcByRegularPrice: number = -1;
    sortByMarginDiffPcByRegularPrice: number = -1;
    sortByMarginDiffSecondByRegularPrice: number = -1;
    sortByIndividualPriceOptStrategy: number = -1;
    sortByIndividualPriceIncreaseLimit: number = -1;
    sortByIndividualPeriodPriceIncreaseLimit: number = -1;
    sortByIndividualPeriod: number = -1;
    sortByIndividualMarginalProfit: number = -1;
    sortByIndividualKviStrategy: number = -1;
    sortByIndividualPercentCorrection: number = -1;
    sortByIndividualNewProductPriceStrategy: number = -1;
    sortByIndividualPriceGapPercent: number = -1;
    sortByIndividualPromoType: number = -1;
    sortByIndividualPromoLift: number = -1;

    sortingField: SortingField | null = null
    defaultStringFiltersValue = {value: '', label: this.$t('salesMonitorTab.tables.selectAll') as string};
    showChangesBlock: boolean = true;
    showPromoChangesBlock: boolean = true;
    showGeneralComparableBlock: boolean = true;
    showGeneralRegularSubTasksResultsBlock: boolean = true;
    showOverlay: boolean = false;
    paramsForDetail: DetailReportsPricesAndCodes = new DetailReportsPricesAndCodes()
    changesPrices: ChangesPrices[] = []
    allTaskIdWithInternalCodesByFilters: TaskIdToInternalCode[] = []
    disableSelectedReports: boolean = true
    eventTriggerOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('salesMonitorTab.tables.baseFilters.all') as string},
        {value: 1, label: this.$t('salesMonitorTab.tables.baseFilters.yes') as string},
        {value: 0, label: this.$t('salesMonitorTab.tables.baseFilters.no') as string},
    ];
    kviOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('salesMonitorTab.tables.baseFilters.all') as string},
        {value: 1, label: 'KVI'},
        {value: 0, label: this.$t('salesMonitorTab.tables.baseFilters.notKvi') as string},
    ];

    ctmOptionsForDetailTable: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('salesMonitorTab.tables.baseFilters.all') as string},
        {value: 1, label: 'CTM'},
        {value: 0, label: this.$t('salesMonitorTab.tables.baseFilters.notCtm') as string},
    ];

    promoResultTableHeader1: TableHeaders[] = [
        {key: 'promoSkuCountInGroup', label: this.$t('salesMonitorTab.tables.promoGroup.promoSkuCountInGroup') as string},
        {key: 'promoAvgPcDiscount', label: this.$t('salesMonitorTab.tables.promoGroup.promoAvgPcDiscount') as string},
        {key: 'promoAvgDiscountDuration', label: this.$t('salesMonitorTab.tables.promoGroup.promoAvgDiscountDuration') as string},
        {key: 'promoPartRevenue', label: this.$t('salesMonitorTab.tables.promoGroup.promoPartRevenue') as string},
        {key: 'promoPartSalesAmount', label: this.$t('salesMonitorTab.tables.promoGroup.promoPartSalesAmount') as string},
        {key: 'promoPartGrossMargin', label: this.$t('salesMonitorTab.tables.promoGroup.promoPartGrossMargin') as string},
        {key: 'promoPartSKU', label: this.$t('salesMonitorTab.tables.promoGroup.promoPartSKU') as string},
    ];

    promoResultTableHeader2: TableHeaders[] = [
        {key: 'promoRealSales', label: this.$t('salesMonitorTab.tables.promoSales.promoRealSales') as string},
        {key: 'promoForecastRealSales', label: this.$t('salesMonitorTab.tables.promoSales.promoForecastRealSales') as string},
        {key: 'promoRealSalesChange', label: this.$t('salesMonitorTab.tables.promoSales.promoRealSalesChange') as string},
        {key: 'promoPcRealSalesChange', label: this.$t('salesMonitorTab.tables.promoSales.promoPcRealSalesChange') as string},
    ];
    promoResultTableHeader3: TableHeaders[] = [
        {key: 'promoRealRevenue', label: this.$t('salesMonitorTab.tables.promoRevenue.promoRealRevenue') as string},
        {key: 'promoForecastRealRevenue', label: this.$t('salesMonitorTab.tables.promoRevenue.promoForecastRealRevenue') as string},
        {key: 'promoRealRevenueChange', label: this.$t('salesMonitorTab.tables.promoRevenue.promoRealRevenueChange') as string},
        {key: 'promoPcRealRevenueChange', label: this.$t('salesMonitorTab.tables.promoRevenue.promoPcRealRevenueChange') as string},
    ];
    promoResultTableHeader4: TableHeaders[] = [
        {key: 'promoRealMargin', label: this.$t('salesMonitorTab.tables.promoMargin.promoRealMargin') as string},
        {key: 'promoForecastRealMargin', label: this.$t('salesMonitorTab.tables.promoMargin.promoForecastRealMargin') as string},
        {key: 'promoRealMarginChange', label: this.$t('salesMonitorTab.tables.promoMargin.promoRealMarginChange') as string},
        {key: 'promoPcRealMarginChange', label: this.$t('salesMonitorTab.tables.promoMargin.promoPcRealMarginChange') as string},
        {key: 'promoRealMarginPc', label: this.$t('salesMonitorTab.tables.promoMargin.promoRealMarginPc') as string},
        {key: 'promoForecastRealMarginPc', label: this.$t('salesMonitorTab.tables.promoMargin.promoForecastRealMarginPc') as string},
        {key: 'promoMarginChangePp', label: this.$t('salesMonitorTab.tables.promoMargin.promoMarginChangePp') as string},
        {key: 'marginLoss', label: this.$t('salesMonitorTab.tables.promoMargin.marginLoss') as string},
        {key: 'marginLossPc', label: this.$t('salesMonitorTab.tables.promoMargin.marginLossPc') as string},
    ];

    selectTaskIdForDetailTable: number[] = [];
    taskIdOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMessageForDetailTable: string[] = [];
    messagesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectGroupNameForDetailTable: string[] = [];
    groupNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectCategoryNameForDetailTable: string[] = [];
    categoryNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectSubcategoryNamesForDetailTable: string[] = [];
    subcategoryNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectFormatNameForDetailTable: string[] = [];
    formatNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectRegionNameForDetailTable: string[] = [];
    regionNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectClusterNameForDetailTable: string[] = [];
    clusterNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectSegmentNameForDetailTable: string[] = [];
    segmentNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectInternalCodeForDetailTable: string[] = [];
    internalCodesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectSkuNameForDetailTable: string[] = [];
    skuNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectCtmBrandForDetailTable: string[] = [];
    ctmBrandsOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectCtmPriceGapForDetailTable: number[] = [];
    ctmPriceGapOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinRetailPriceForDetailTable: number[] = [];
    minRetailPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMaxRetailPriceForDetailTable: number[] = [];
    maxRetailPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectKeyProduct1ForDetailTable: string[] = [];
    keyProduct1OptionsForDetailTable: Array<SelectBox<string>> = [];

    selectKeyProduct2ForDetailTable: string[] = [];
    keyProduct2OptionsForDetailTable: Array<SelectBox<string>> = [];

    selectRecipeAttributeForDetailTable: string[] = [];
    recipeAttributeOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectTreatmentAttributeForDetailTable: number[] = [];
    treatmentAttributeOptionsForDetailTable: Array<SelectBox<number>> = [];

    vitalMedicinesOptionsForDetailTable: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('salesMonitorTab.tables.baseFilters.all') as string},
        {value: 1, label: this.$t('salesMonitorTab.tables.baseFilters.yes') as string},
        {value: 0, label: this.$t('salesMonitorTab.tables.baseFilters.no') as string},
    ];

    selectProducerPriceForDetailTable: number[] = [];
    producerPricesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectExtraChargePcForDetailTable: number[] = [];
    extraChargePcsOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRegistrationPriceForDetailTable: number[] = [];
    registrationPricesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSegmentPriceForDetailTable: ReportDetailSegments[] = [];
    segmentPriceOptionsForDetailTable: Array<SelectBox<ReportDetailSegments>> = [];

    selectSkuLineForDetailTable: string[] = [];
    skuLineOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectPurchasePriceForDetailTable: number[] = [];
    purchasePriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectPromoPurchasePriceForDetailTable: number[] = [];
    promoPurchasePriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectAvgRegularPriceForDetailTable: number[] = [];
    avgRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectAvgCashPriceForDetailTable: number[] = [];
    avgCashPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectAvgCheckPriceForDetailTable: number[] = [];
    avgCheckPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRegularPriceForDetailTable: number[] = [];
    regularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginLastPriceForDetailTable: number[] = [];
    marginLastPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinCompetitorPriceForDetailTable: number[] = [];
    minCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinCompetitorNameForDetailTable: string[] = [];
    minCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectMaxCompetitorPriceForDetailTable: number[] = [];
    maxCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMaxCompetitorNameForDetailTable: string[] = [];
    maxCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectAvgCompetitorPriceForDetailTable: number[] = [];
    avgCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectLastCompetitorPriceForDetailTable: number[] = [];
    lastCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinPromoCompetitorPriceForDetailTable: number[] = [];
    minPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinPromoCompetitorNameForDetailTable: string[] = [];
    minPromoCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectMaxPromoCompetitorPriceForDetailTable: number[] = [];
    maxPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMaxPromoCompetitorNameForDetailTable: string[] = [];
    maxPromoCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectMedianPromoCompetitorPriceForDetailTable: number[] = [];
    medianPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectLastPromoCompetitorPriceForDetailTable: number[] = [];
    lastPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectPiForDetailTable: number[] = [];
    piOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectActualSalesForDetailTable: number[] = [];
    actualSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectActualRevenueForDetailTable: number[] = [];
    actualRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectActualMarginForDetailTable: number[] = [];
    actualMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectActualMarginPercentForDetailTable: number[] = [];
    actualMarginPercentOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectComparableSalesForDetailTable: number[] = [];
    comparableSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectComparableRevenueForDetailTable: number[] = [];
    comparableRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectComparableMarginForDetailTable: number[] = [];
    comparableMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectComparableMarginPcForDetailTable: number[] = [];
    comparableMarginPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectNewPriceForDetailTable: number[] = [];
    newPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectNewPromoPriceForDetailTable: number[] = [];
    newPromoPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectCorrectedRegularPriceForDetailTable: number[] = [];
    correctedRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectCorrectedPromoPriceForDetailTable: number[] = [];
    correctedPromoPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectNewMarginPcForDetailTable: number[] = [];
    newMarginPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectNewPIForDetailTable: number[] = [];
    newPIOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectDeltaDiffPriceForDetailTable: number[] = [];
    deltaDiffPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectPriceDiffPcForDetailTable: number[] = [];
    priceDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffForDetailTable: number[] = [];
    marginDiffOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangedPIForDetailTable: number[] = [];
    changedPIPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectDiscountDepthForDetailTable: number[] = [];
    discountDepthOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectDiscountDurationForDetailTable: number[] = [];
    discountDurationOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectExitSegmentForDetailTable: string[] = [];
    exitSegmentOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectCoeffElasticityForDetailTable: number[] = [];
    coeffElasticityPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectPromoCoeffElasticityForDetailTable: number[] = [];
    promoCoeffElasticityPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSalesForecastForDetailTable: number[] = [];
    salesForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRevenueForecastForDetailTable: number[] = [];
    revenueForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginForecastForDetailTable: number[] = [];
    marginForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginForecastPcForDetailTable: number[] = [];
    marginForecastPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeSalesForDetailTable: number[] = [];
    changeSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeRevenueForDetailTable: number[] = [];
    changeRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeMarginForDetailTable: number[] = [];
    changeMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSalesDiffPcForDetailTable: number[] = [];
    salesDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRevenueDiffPcForDetailTable: number[] = [];
    revenueDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffPcForDetailTable: number[] = [];
    marginDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffSecondForDetailTable: number[] = [];
    marginDiffSecondOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualPromoTypeForDetailTable: string[] = [];
    individualPromoTypeOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualPromoLiftForDetailTable: number[] = [];
    individualPromoLiftOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSalesForecastByRegularPriceForDetailTable: number[] = [];
    salesForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRevenueForecastByRegularPriceForDetailTable: number[] = [];
    revenueForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginForecastByRegularPriceForDetailTable: number[] = [];
    marginForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginForecastByRegularPricePcForDetailTable: number[] = [];
    marginForecastByRegularPricePcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeSalesByRegularPriceForDetailTable: number[] = [];
    changeSalesByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeRevenueByRegularPriceForDetailTable: number[] = [];
    changeRevenueByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeMarginByRegularPriceForDetailTable: number[] = [];
    changeMarginByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSalesDiffPcByRegularPriceForDetailTable: number[] = [];
    salesDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRevenueDiffPcByRegularPriceForDetailTable: number[] = [];
    revenueDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffPcByRegularPriceForDetailTable: number[] = [];
    marginDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffSecondByRegularPriceForDetailTable: number[] = [];
    marginDiffSecondByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualPriceOptStrategyForDetailTable: string[] = [];
    individualPriceOptStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualPriceIncreaseLimitForDetailTable: number[] = [];
    individualPriceIncreaseLimitOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualPeriodPriceIncreaseLimitForDetailTable: number[] = [];
    individualPeriodPriceIncreaseLimitOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualPeriodForDetailTable: string[] = [];
    individualPeriodOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualMarginalProfitForDetailTable: number[] = [];
    individualMarginalProfitOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualKviStrategyForDetailTable: string[] = [];
    individualKviStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualPercentCorrectionForDetailTable: string[] = [];
    individualPercentCorrectionOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualNewProductPriceStrategyForDetailTable: string[] = [];
    individualNewProductPriceStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualPriceGapPercentForDetailTable: number[] = [];
    individualPriceGapPercentOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectBatchNumberForDetailTable: string[] = [];
    batchNumberOptionsForDetailTable: Array<SelectBox<string>> = [];

    grossIncomeByLastPriceTableHeader: TableHeaders[] = [
        {key: 'promoAvgPcDiscount', label: this.$t('salesMonitorTab.tables.promoGroup.promoAvgPcDiscount') as string},
        {key: 'promoPartRevenue', label: this.$t('salesMonitorTab.tables.promoGroup.promoPartRevenue') as string},
        {key: 'promoPartSalesAmount', label: this.$t('salesMonitorTab.tables.promoGroup.promoPartSalesAmount') as string},
        {key: 'promoPartGrossMargin', label: this.$t('salesMonitorTab.tables.promoGroup.promoPartGrossMargin') as string},
        {key: 'promoPartSKU', label: this.$t('salesMonitorTab.tables.promoGroup.promoPartSKU') as string},
    ];

    salesByLastPriceTableHeader: TableHeaders[] = [
        {key: 'sumSalesForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.sumSalesForecastByRegularPrice') as string},
        {key: 'forecastAmount', label: this.$t('salesMonitorTab.tables.commonCols.forecastAmount') as string},
        {key: 'changeForecastSalesByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastSalesByRegularPrice') as string},
        {key: 'changeForecastSalesPcByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastSalesPcByRegularPrice') as string},
    ];

    revenueByLastPriceTableHeader: TableHeaders[] = [
        {key: 'sumRevenueForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.sumRevenueForecastByRegularPrice') as string},
        {key: 'forecastRevenue', label: this.$t('salesMonitorTab.tables.commonCols.forecastRevenue') as string},
        {key: 'changeForecastRevenueByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastRevenueByRegularPrice') as string},
        {key: 'changeForecastRevenuePcByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastRevenuePcByRegularPrice') as string},
    ];
    generalPromoResultTableHeader2: TableHeaders[] = [
        {key: 'realSalesAmount', label: this.$t('salesMonitorTab.tables.promoSales.promoRealSales') as string},
        {key: 'forecastAmount', label: this.$t('salesMonitorTab.tables.promoSales.promoForecastRealSales') as string},
        {key: 'amountChange', label: this.$t('salesMonitorTab.tables.promoSales.promoRealSalesChange') as string},
        {key: 'amountChangePc', label: this.$t('salesMonitorTab.tables.promoSales.promoPcRealSalesChange') as string},
    ];
    generalPromoResultTableHeader3: TableHeaders[] = [
        {key: 'revenueReal', label: this.$t('salesMonitorTab.tables.promoRevenue.promoRealRevenue') as string},
        {key: 'forecastRevenue', label: this.$t('salesMonitorTab.tables.promoRevenue.promoForecastRealRevenue') as string},
        {key: 'revenueChange', label: this.$t('salesMonitorTab.tables.promoRevenue.promoRealRevenueChange') as string},
        {key: 'revenueChangePc', label: this.$t('salesMonitorTab.tables.promoRevenue.promoPcRealRevenueChange') as string},
    ];
    generalPromoResultTableHeader4: TableHeaders[] = [
        {key: 'marginReal', label: this.$t('salesMonitorTab.tables.promoMargin.promoRealMargin') as string},
        {key: 'forecastMargin', label: this.$t('salesMonitorTab.tables.promoMargin.promoForecastRealMargin') as string},
        {key: 'marginChange', label: this.$t('salesMonitorTab.tables.promoMargin.promoRealMarginChange') as string},
        {key: 'marginChangePc', label: this.$t('salesMonitorTab.tables.promoMargin.promoRealMarginChangePc') as string},
        {key: 'marginRealPc', label: this.$t('salesMonitorTab.tables.promoMargin.promoRealMarginPc') as string},
        {key: 'forecastMarginPc', label: this.$t('salesMonitorTab.tables.promoMargin.promoForecastRealMarginPc') as string},
        {key: 'marginChangePp', label: this.$t('salesMonitorTab.tables.promoMargin.promoMarginChangePp') as string},
    ];
    generalResultChanges1: TableHeaders[] = [
        {key: 'skuCountInGroup', label: this.$t('salesMonitorTab.tables.commonCols.skuCountInGroup') as string},
        {key: 'priceChangedCount', label: this.$t('salesMonitorTab.tables.commonCols.priceChangedCount') as string},
        {key: 'avgPcPriceChange', label: this.$t('salesMonitorTab.tables.commonCols.avgPcPriceChange') as string},
        {key: 'avgPcIncreasePrice', label: this.$t('salesMonitorTab.tables.commonCols.avgPcIncreasePrice') as string},
        {key: 'avgPcPriceDecrease', label: this.$t('salesMonitorTab.tables.commonCols.avgPcPriceDecrease') as string},
        {key: 'marginLoss', label: this.$t('salesMonitorTab.tables.commonCols.marginLoss') as string},
        {key: 'marginLossPc', label: this.$t('salesMonitorTab.tables.commonCols.marginLossPc') as string},
    ];
    generalResultChanges2: TableHeaders[] = [
        {key: 'priceIncreaseCount', label: this.$t('salesMonitorTab.tables.commonCols.priceIncreaseCount') as string},
        {key: 'avgPcIncreasePrice', label: this.$t('salesMonitorTab.tables.commonCols.avgPcIncreasePrice') as string},
        {key: 'priceDecreaseCount', label: this.$t('salesMonitorTab.tables.commonCols.priceDecreaseCount') as string},
    ];
    generalResultChanges3: TableHeaders[] = [
        {key: 'avgPcPriceDecrease', label: this.$t('salesMonitorTab.tables.commonCols.avgPcPriceDecrease') as string},
        {key: 'settlementDate', label: this.$t('salesMonitorTab.tables.commonCols.settlementDate') as string},
        {key: 'forecastDate', label: this.$t('salesMonitorTab.tables.commonCols.forecastDate') as string},
    ];
    generalPromoResultChanges1: TableHeaders[] = [
        {key: 'skuCountInGroup', label: this.$t('salesMonitorTab.tables.commonCols.skuCountInGroup') as string},
        {key: 'priceChangedCount', label: this.$t('salesMonitorTab.tables.commonCols.priceChangedCount') as string},
        {key: 'avgPcPriceChange', label: this.$t('salesMonitorTab.tables.commonCols.avgPcPriceChange') as string},
    ];
    generalPromoResultChanges2: TableHeaders[] = [
        {key: 'priceIncreaseCount', label: this.$t('salesMonitorTab.tables.commonCols.priceIncreaseCount') as string},
        {key: 'avgPcIncreasePrice', label: this.$t('salesMonitorTab.tables.commonCols.avgPcIncreasePrice') as string},
        {key: 'priceDecreaseCount', label: this.$t('salesMonitorTab.tables.commonCols.priceDecreaseCount') as string},
    ];
    generalPromoResultChanges3: TableHeaders[] = [
        {key: 'avgPcPriceDecrease', label: this.$t('salesMonitorTab.tables.commonCols.avgPcPriceDecrease') as string},
        {key: 'settlementDate', label: this.$t('salesMonitorTab.tables.commonCols.settlementDate') as string},
        {key: 'forecastDate', label: this.$t('salesMonitorTab.tables.commonCols.forecastDate') as string},
    ];
    generalResultTableHeader2: TableHeaders[] = [
        {key: 'comparableSalesAmount', label: this.$t('salesMonitorTab.tables.commonCols.comparableSalesAmount') as string},
        {key: 'forecastAmount', label: this.$t('salesMonitorTab.tables.commonCols.forecastAmount') as string},
        {key: 'amountChange', label: this.$t('salesMonitorTab.tables.commonCols.amountChange') as string},
        {key: 'amountChangePc', label: this.$t('salesMonitorTab.tables.commonCols.amountChangePc') as string},
    ];

    generalResultTableHeader3: TableHeaders[] = [
        {key: 'revenueComparable', label: this.$t('salesMonitorTab.tables.commonCols.revenueComparable') as string},
        {key: 'forecastRevenue', label: this.$t('salesMonitorTab.tables.commonCols.forecastRevenue') as string},
        {key: 'revenueChange', label: this.$t('salesMonitorTab.tables.commonCols.revenueChange') as string},
        {key: 'revenueChangePc', label: this.$t('salesMonitorTab.tables.commonCols.revenueChangePc') as string},
    ];

    generalResultTableHeader4: TableHeaders[] = [
        {key: 'marginComparable', label: this.$t('salesMonitorTab.tables.commonCols.marginComparable') as string},
        {key: 'forecastMargin', label: this.$t('salesMonitorTab.tables.commonCols.forecastMargin') as string},
        {key: 'marginChange', label: this.$t('salesMonitorTab.tables.commonCols.marginChange') as string},
        {key: 'marginChangePc', label: this.$t('salesMonitorTab.tables.commonCols.marginChangePc') as string},
        {key: 'marginComparablePc', label: this.$t('salesMonitorTab.tables.commonCols.marginComparablePc') as string},
        {key: 'forecastMarginPc', label: this.$t('salesMonitorTab.tables.commonCols.forecastMarginPc') as string},
        {key: 'marginChangePp', label: this.$t('salesMonitorTab.tables.commonCols.marginChangePp') as string},
    ];

    regularDetailReport: TableHeaders[] = [
        {key: 'activeProduct', label: '', stickyColumn: true, thAttr: this.thAttrTitle, thClass: ['croppedText']},
        {key: 'taskId', label: this.$t('salesMonitorTab.tables.reportColumns.taskId') as string, sortable: true, thAttr: this.thAttrTitle, thClass: ['croppedText']},
        {
            key: 'message',
            label: this.$t('salesMonitorTab.tables.reportColumns.status') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'groupName',
            label: this.$t('salesMonitorTab.tables.reportColumns.group') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'categoryName',
            label: this.$t('salesMonitorTab.tables.reportColumns.category') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'subCategoryName',
            label: this.$t('salesMonitorTab.tables.reportColumns.subcategory') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'formatName',
            label: this.$t('salesMonitorTab.tables.reportColumns.format') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'regionName',
            label: this.$t('salesMonitorTab.tables.reportColumns.region') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'clusterName',
            label: this.$t('salesMonitorTab.tables.reportColumns.cluster') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'productSegmentName',
            label: this.$t('salesMonitorTab.tables.reportColumns.segment') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'internalCode',
            label: this.$t('salesMonitorTab.tables.reportColumns.internalCode') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'batchNumber',
            label: this.$t('salesMonitorTab.tables.reportColumns.batchNumber') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'skuName',
            label: this.$t('salesMonitorTab.tables.reportColumns.skuName') as string,
            stickyColumn: true,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
    ];

    promoDetailReport: TableHeaders[] = [
        {key: 'activeProduct', label: '', stickyColumn: true, thAttr: this.thAttrTitle, thClass: ['croppedText']},
        {key: 'taskId', label: this.$t('salesMonitorTab.tables.reportColumns.taskId') as string, sortable: true, thAttr: this.thAttrTitle, thClass: ['croppedText']},
        {
            key: 'message',
            label: this.$t('salesMonitorTab.tables.reportColumns.message') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'groupName',
            label: this.$t('salesMonitorTab.tables.reportColumns.group') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'categoryName',
            label: this.$t('salesMonitorTab.tables.reportColumns.category') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'subCategoryName',
            label: this.$t('salesMonitorTab.tables.reportColumns.subcategory') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'formatName',
            label: this.$t('salesMonitorTab.tables.reportColumns.format') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'regionName',
            label: this.$t('salesMonitorTab.tables.reportColumns.region') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'clusterName',
            label: this.$t('salesMonitorTab.tables.reportColumns.cluster') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'productSegmentName',
            label: this.$t('salesMonitorTab.tables.reportColumns.segment') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'internalCode',
            label: this.$t('salesMonitorTab.tables.reportColumns.internalCode') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'skuName',
            label: this.$t('salesMonitorTab.tables.reportColumns.skuName') as string,
            stickyColumn: true,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
    ];

    packageRegularFullHeaderReport: TableHeaders[] = [
        {key: 'fileResult', label: this.$t('salesMonitorTab.tables.reportColumns.actions') as string},
        {key: 'taskId', label: this.$t('salesMonitorTab.tables.reportColumns.taskId') as string},
        {key: 'forecastDate', label: this.$t('salesMonitorTab.tables.reportColumns.date') as string},
        {key: 'message', label: this.$t('salesMonitorTab.tables.reportColumns.message') as string},
        {key: 'groupName', label: this.$t('salesMonitorTab.tables.reportColumns.group') as string},
        {key: 'categoryName', label: this.$t('salesMonitorTab.tables.reportColumns.category') as string},
        {key: 'subCategoryName', label: this.$t('salesMonitorTab.tables.reportColumns.subcategory') as string},
        {key: 'formatName', label: this.$t('salesMonitorTab.tables.reportColumns.format') as string},
        {key: 'regionName', label: this.$t('salesMonitorTab.tables.reportColumns.region') as string},
        {key: 'clusterName', label: this.$t('salesMonitorTab.tables.reportColumns.cluster') as string},
        {key: 'sumSalesForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.sumSalesForecastByRegularPrice') as string},
        {key: 'forecastAmount', label: this.$t('salesMonitorTab.tables.commonCols.forecastAmount') as string},
        {key: 'changeForecastSalesByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastSalesByRegularPrice') as string},
        {key: 'changeForecastSalesPcByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastSalesPcByRegularPrice') as string},
        {key: 'sumRevenueForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.sumRevenueForecastByRegularPrice') as string},
        {key: 'forecastRevenue', label: this.$t('salesMonitorTab.tables.commonCols.forecastRevenue') as string},
        {key: 'changeForecastRevenueByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastRevenueByRegularPrice') as string},
        {key: 'changeForecastRevenuePcByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastRevenuePcByRegularPrice') as string},
        {key: 'sumMarginForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.sumMarginForecastByRegularPrice') as string},
        {key: 'forecastMargin', label: this.$t('salesMonitorTab.tables.commonCols.forecastMargin') as string},
        {key: 'changeForecastMarginByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastMarginByRegularPrice') as string},
        {key: 'changeForecastMarginPcByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.changeForecastMarginPcByRegularPrice') as string},
        {key: 'sumMarginForecastPcByRegularPrice', label: this.$t('salesMonitorTab.tables.commonCols.sumMarginForecastPcByRegularPrice') as string},
        {key: 'forecastMarginPc', label: this.$t('salesMonitorTab.tables.commonCols.forecastMarginPc') as string},
        {key: 'changeMarginByRegularPricePp', label: this.$t('salesMonitorTab.tables.commonCols.changeMarginByRegularPricePp') as string},
        {key: 'ftpSendingStatus', label: ''},
    ];
    packageRegularFullHeaderReports: ITableHeaders[] = [
        {dataIndex: 'fileResult', title: this.$t('salesMonitorTab.tables.reportColumns.actions') as string, width: 200, fixed: "left" , scopedSlots: { customRender: 'fileResult'}},
        {dataIndex: 'note', title: this.$t('salesMonitorTab.tables.reportColumns.note') as string, width: 150, scopedSlots: { customRender: 'note' }},
        {dataIndex: 'taskId', title: this.$t('salesMonitorTab.tables.reportColumns.taskId') as string, width: 100, scopedSlots: { customRender: 'taskId' }},
        {dataIndex: 'forecastDate', title: this.$t('salesMonitorTab.tables.reportColumns.date') as string, scopedSlots: { customRender: 'forecastDate' }, width: 150},
        {dataIndex: 'userFio', title: this.$t('salesMonitorTab.tables.reportColumns.userFio') as string, scopedSlots: { customRender: 'userFio' }, width: 130},
        {dataIndex: 'message', title: this.$t('salesMonitorTab.tables.reportColumns.message') as string, scopedSlots: { customRender: 'message' }, width: 200},
        {dataIndex: 'saleName', title: this.$t('salesMonitorTab.tables.reportColumns.saleName') as string, width: 200},
        {dataIndex: 'saleType', title: this.$t('salesMonitorTab.tables.reportColumns.saleType') as string, scopedSlots: { customRender: 'saleType' }, width: 200},
        {dataIndex: 'saleStartDate', title: this.$t('salesMonitorTab.tables.reportColumns.saleStartDate') as string, scopedSlots: { customRender: 'saleStartDate' }, width: 190},
        {dataIndex: 'saleEndDate', title: this.$t('salesMonitorTab.tables.reportColumns.saleEndDate') as string, scopedSlots: { customRender: 'saleEndDate' }, width: 220},
        {dataIndex: 'saleRemains', title: this.$t('salesMonitorTab.tables.reportColumns.saleRemains') as string, width: 120},
        {dataIndex: 'groupName', title: this.$t('salesMonitorTab.tables.reportColumns.group') as string, scopedSlots: { customRender: 'groupName' }, width: 200},
        {dataIndex: 'categoryName', title: this.$t('salesMonitorTab.tables.reportColumns.category') as string, scopedSlots: { customRender: 'categoryName' }, width: 200},
        {dataIndex: 'subCategoryName', title: this.$t('salesMonitorTab.tables.reportColumns.subcategory') as string, scopedSlots: { customRender: 'subCategoryName' }, width: 200},
        {dataIndex: 'formatName', title: this.$t('salesMonitorTab.tables.reportColumns.format') as string, scopedSlots: { customRender: 'formatName' }, width: 200},
        {dataIndex: 'regionName', title: this.$t('salesMonitorTab.tables.reportColumns.region') as string, scopedSlots: { customRender: 'regionName' }, width: 200},
        {dataIndex: 'clusterName', title: this.$t('salesMonitorTab.tables.reportColumns.cluster') as string, scopedSlots: { customRender: 'clusterName' }, width: 200},

        {dataIndex: 'promoAvgPcDiscount', title: this.$t('salesMonitorTab.tables.promoGroup.promoAvgPcDiscount') as string, scopedSlots: { customRender: 'promoAvgPcDiscount' }, width: 200},
        {dataIndex: 'promoPartRevenue', title: this.$t('salesMonitorTab.tables.promoGroup.promoPartRevenue') as string, scopedSlots: { customRender: 'promoPartRevenue' }, width: 200},
        {dataIndex: 'promoPartSalesAmount', title: this.$t('salesMonitorTab.tables.promoGroup.promoPartSalesAmount') as string, scopedSlots: { customRender: 'promoPartSalesAmount' }, width: 200},
        {dataIndex: 'promoPartGrossMargin', title: this.$t('salesMonitorTab.tables.promoGroup.promoPartGrossMargin') as string, scopedSlots: { customRender: 'promoPartGrossMargin' }, width: 200},
        {dataIndex: 'promoPartSKU', title: this.$t('salesMonitorTab.tables.promoGroup.promoPartSKU') as string, scopedSlots: { customRender: 'promoPartSKU' }, width: 200},

        {dataIndex: 'promoRealMargin', title: this.$t('salesMonitorTab.tables.promoMargin.promoRealMargin') as string, scopedSlots: { customRender: 'promoRealMargin' }, width: 200},
        {dataIndex: 'promoForecastRealMargin', title: this.$t('salesMonitorTab.tables.promoMargin.promoForecastRealMargin') as string, scopedSlots: { customRender: 'promoForecastRealMargin' }, width: 200},
        {dataIndex: 'promoRealMarginChange', title: this.$t('salesMonitorTab.tables.promoMargin.promoRealMarginChange') as string, scopedSlots: { customRender: 'promoRealMarginChange' }, width: 200},
        {dataIndex: 'promoPcRealMarginChange', title: this.$t('salesMonitorTab.tables.promoMargin.promoRealMarginChangePc') as string, scopedSlots: { customRender: 'promoPcRealMarginChange' }, width: 200},
        {dataIndex: 'promoRealMarginPc', title: this.$t('salesMonitorTab.tables.promoMargin.promoRealMarginPc') as string, scopedSlots: { customRender: 'promoRealMarginPc' }, width: 200},
        {dataIndex: 'promoForecastRealMarginPc', title: this.$t('salesMonitorTab.tables.promoMargin.promoForecastRealMarginPc') as string, scopedSlots: { customRender: 'promoForecastRealMarginPc' }, width: 200},
        {dataIndex: 'promoMarginChangePp', title: this.$t('salesMonitorTab.tables.promoMargin.promoMarginChangePp') as string, scopedSlots: { customRender: 'promoMarginChangePp' }, width: 200},
        {dataIndex: 'marginLoss', title: this.$t('salesMonitorTab.tables.commonCols.marginLoss') as string, scopedSlots: { customRender: 'marginLoss' }, width: 200},
        {dataIndex: 'marginLossPc', title: this.$t('salesMonitorTab.tables.commonCols.marginLossPc') as string, scopedSlots: { customRender: 'marginLossPc' }, width: 220},

        {dataIndex: 'promoRealSales', title: this.$t('salesMonitorTab.tables.promoSales.promoRealSales') as string, scopedSlots: { customRender: 'promoRealSales' }, width: 200},
        {dataIndex: 'promoForecastRealSales', title: this.$t('salesMonitorTab.tables.promoSales.promoForecastRealSales') as string, scopedSlots: { customRender: 'promoForecastRealSales' }, width: 200},
        {dataIndex: 'promoRealSalesChange', title: this.$t('salesMonitorTab.tables.promoSales.promoRealSalesChange') as string, scopedSlots: { customRender: 'promoRealSalesChange' }, width: 200},
        {dataIndex: 'promoPcRealSalesChange', title: this.$t('salesMonitorTab.tables.promoSales.promoPcRealSalesChange') as string, scopedSlots: { customRender: 'promoPcRealSalesChange' }, width: 200},

        {dataIndex: 'promoRealRevenue', title: this.$t('salesMonitorTab.tables.promoRevenue.promoRealRevenue') as string, scopedSlots: { customRender: 'promoRealRevenue' }, width: 200},
        {dataIndex: 'promoForecastRealRevenue', title: this.$t('salesMonitorTab.tables.promoRevenue.promoForecastRealRevenue') as string, scopedSlots: { customRender: 'promoForecastRealRevenue' }, width: 200},
        {dataIndex: 'promoRealRevenueChange', title: this.$t('salesMonitorTab.tables.promoRevenue.promoRealRevenueChange') as string, scopedSlots: { customRender: 'promoRealRevenueChange' }, width: 200},
        {dataIndex: 'promoPcRealRevenueChange', title: this.$t('salesMonitorTab.tables.promoRevenue.promoPcRealRevenueChange') as string, scopedSlots: { customRender: 'promoPcRealRevenueChange' }, width: 200},
    ];

    allDetailReportFields: TableHeaders[] = [
        {key: 'recipeAttribute', label: this.$t('salesMonitorTab.tables.detailColumns.recipeAttribute') as string},
        {key: 'treatmentAttribute', label: this.$t('salesMonitorTab.tables.detailColumns.treatmentAttribute') as string},
        {key: 'vitalMedicine', label: this.$t('salesMonitorTab.tables.detailColumns.vitalMedicine') as string},
        {key: 'producerPrice', label: this.$t('salesMonitorTab.tables.detailColumns.producerPrice') as string},
        {key: 'extraChargePc', label: this.$t('salesMonitorTab.tables.detailColumns.extraChargePc') as string},
        {key: 'registrationPrice', label: this.$t('salesMonitorTab.tables.detailColumns.registrationPrice') as string},
        {key: 'eventTrigger', label: this.$t('salesMonitorTab.tables.detailColumns.eventTrigger') as string},
        {key: 'kvi', label: this.$t('salesMonitorTab.tables.detailColumns.kvi') as string},
        {key: 'ctm', label: this.$t('salesMonitorTab.tables.detailColumns.ctm') as string},
        {key: 'ctmBrand', label: this.$t('salesMonitorTab.tables.detailColumns.ctmBrand') as string},
        {key: 'ctmPriceGap', label: this.$t('salesMonitorTab.tables.detailColumns.ctmPriceGap') as string},
        {key: 'minRetailPrice', label: this.$t('salesMonitorTab.tables.detailColumns.minRetailPrice') as string},
        {key: 'maxRetailPrice', label: this.$t('salesMonitorTab.tables.detailColumns.maxRetailPrice') as string},
        {key: 'omnichannelStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelStrategy') as string},
        {key: 'omnichannelFixedGapType', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelFixedGapType') as string},
        {key: 'omnichannelGap', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelGap') as string},
        {key: 'omnichannelApplyCompetitorPrices', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelApplyCompetitorPrices') as string},
        {key: 'omnichannelMinProfitabilityLimit', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelMinProfitabilityLimit') as string},
        {key: 'omnichannelBaseChannelPrice', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelBaseChannelPrice') as string},
        {key: 'keyProduct1', label: this.$t('salesMonitorTab.tables.detailColumns.keyProduct1') as string},
        {key: 'keyProduct2', label: this.$t('salesMonitorTab.tables.detailColumns.keyProduct2') as string},
        {key: 'segment', label: this.$t('salesMonitorTab.tables.detailColumns.segment') as string},
        {key: 'skuLine', label: this.$t('salesMonitorTab.tables.detailColumns.skuLine') as string},
        {key: 'purchasePrice', label: this.$t('salesMonitorTab.tables.detailColumns.purchasePrice') as string},
        {key: 'avgRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgRegularPrice') as string},
        {key: 'avgCashPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgCashPrice') as string},
        {key: 'avgCheckPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgCheckPrice') as string},
        {key: 'regularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.regularPrice') as string},
        {key: 'marginLastPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginLastPrice') as string},
        {key: 'minCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorPrice') as string},
        {key: 'minCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string},
        {key: 'maxCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.maxCompetitorPrice') as string},
        {key: 'maxCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.maxCompetitorName') as string},
        {key: 'avgCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgCompetitorPrice') as string},
        {key: 'lastCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.lastCompetitorPrice') as string},
        {key: 'pi', label: this.$t('salesMonitorTab.tables.detailColumns.pi') as string},
        {key: 'actualSales', label: this.$t('salesMonitorTab.tables.detailColumns.actualSales') as string},
        {key: 'actualRevenue', label: this.$t('salesMonitorTab.tables.detailColumns.actualRevenue') as string},
        {key: 'actualMargin', label: this.$t('salesMonitorTab.tables.detailColumns.actualMargin') as string},
        {key: 'actualMarginPercent', label: this.$t('salesMonitorTab.tables.detailColumns.actualMarginPercent') as string},
        {key: 'comparableSales', label: this.$t('salesMonitorTab.tables.detailColumns.comparableSales') as string},
        {key: 'comparableRevenue', label: this.$t('salesMonitorTab.tables.detailColumns.comparableRevenue') as string},
        {key: 'comparableMargin', label: this.$t('salesMonitorTab.tables.detailColumns.comparableMargin') as string},
        {key: 'comparableMarginPc', label: this.$t('salesMonitorTab.tables.detailColumns.comparableMarginPc') as string},
        {key: 'newPrice', label: this.$t('salesMonitorTab.tables.detailColumns.newPrice') as string},
        {key: 'correctedRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.correctedRegularPrice') as string},
        {key: 'newMarginPc', label: this.$t('salesMonitorTab.tables.detailColumns.newMarginPc') as string},
        {key: 'newPI', label: this.$t('salesMonitorTab.tables.detailColumns.newPI') as string},
        {key: 'deltaDiffPrice', label: this.$t('salesMonitorTab.tables.detailColumns.deltaDiffPrice') as string},
        {key: 'priceDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.priceDiffPc') as string},
        {key: 'marginDiff', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiff') as string},
        {key: 'changedPI', label: this.$t('salesMonitorTab.tables.detailColumns.changedPI') as string},
        {key: 'exitSegment', label: this.$t('salesMonitorTab.tables.detailColumns.exitSegment') as string},
        {key: 'coeffElasticity', label: this.$t('salesMonitorTab.tables.detailColumns.coeffElasticity') as string},
        {key: 'salesForecast', label: this.$t('salesMonitorTab.tables.detailColumns.salesForecast') as string},
        {key: 'revenueForecast', label: this.$t('salesMonitorTab.tables.detailColumns.revenueForecast') as string},
        {key: 'marginForecast', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecast') as string},
        {key: 'marginForecastPc', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecastPc') as string},
        {key: 'changeSales', label: this.$t('salesMonitorTab.tables.detailColumns.changeSales') as string},
        {key: 'changeRevenue', label: this.$t('salesMonitorTab.tables.detailColumns.changeRevenue') as string},
        {key: 'changeMargin', label: this.$t('salesMonitorTab.tables.detailColumns.changeMargin') as string},
        {key: 'salesDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPc') as string},
        {key: 'revenueDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPc') as string},
        {key: 'marginDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPc') as string},
        {key: 'marginDiffSecond', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffSecond') as string},
        {key: 'salesForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.salesForecastByRegularPrice') as string},
        {key: 'revenueForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.revenueForecastByRegularPrice') as string},
        {key: 'marginForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecastByRegularPrice') as string},
        {key: 'marginForecastByRegularPricePc', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecastByRegularPricePc') as string},
        {key: 'changeSalesByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.changeSalesByRegularPrice') as string},
        {key: 'changeRevenueByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.changeRevenueByRegularPrice') as string},
        {key: 'changeMarginByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.changeMarginByRegularPrice') as string},
        {key: 'salesDiffPcByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPcByRegularPrice') as string},
        {key: 'revenueDiffPcByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPcByRegularPrice') as string},
        {key: 'marginDiffPcByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPcByRegularPrice') as string},
        {key: 'marginDiffSecondByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffSecondByRegularPrice') as string},
        {key: 'individualPriceOptStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.individualPriceOptStrategy') as string},
        {key: 'individualPriceIncreaseLimit', label: this.$t('salesMonitorTab.tables.detailColumns.individualPriceIncreaseLimit') as string},
        {key: 'individualPeriodPriceIncreaseLimit', label: this.$t('salesMonitorTab.tables.detailColumns.individualPeriodPriceIncreaseLimit') as string},
        {key: 'individualPeriod', label: this.$t('salesMonitorTab.tables.detailColumns.individualPeriod') as string},
        {key: 'individualMarginalProfit', label: this.$t('salesMonitorTab.tables.detailColumns.individualMarginalProfit') as string},
        {key: 'individualKviStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.individualKviStrategy') as string},
        {key: 'individualPercentCorrection', label: this.$t('salesMonitorTab.tables.detailColumns.individualPercentCorrection') as string},
        {key: 'individualNewProductPriceStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.individualNewProductPriceStrategy') as string},
        {key: 'individualPriceGapPercent', label: this.$t('salesMonitorTab.tables.detailColumns.individualPriceGapPercent') as string},
        {key: 'newPriceHistory', label: this.$t('salesMonitorTab.tables.detailColumns.newPriceHistory') as string},
        {key: 'promoPurchasePrice', label: this.$t('salesMonitorTab.tables.detailColumns.promoPurchasePrice') as string},
        {key: 'minPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.minPromoCompetitorPrice') as string},
        {key: 'minPromoCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.minPromoCompetitorName') as string},
        {key: 'maxPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.maxPromoCompetitorPrice') as string},
        {key: 'maxPromoCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.maxPromoCompetitorName') as string},
        {key: 'medianPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.medianPromoCompetitorPrice') as string},
        {key: 'lastPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.lastPromoCompetitorPrice') as string},
        {key: 'newPromoPrice', label: this.$t('salesMonitorTab.tables.detailColumns.newPromoPrice') as string},
        {key: 'correctedPromoPrice', label: this.$t('salesMonitorTab.tables.detailColumns.correctedPromoPrice') as string},
        {key: 'discountDepth', label: this.$t('salesMonitorTab.tables.detailColumns.discountDepth') as string},
        {key: 'discountDuration', label: this.$t('salesMonitorTab.tables.detailColumns.discountDuration') as string},
        {key: 'promoCoeffElasticity', label: this.$t('salesMonitorTab.tables.detailColumns.promoCoeffElasticity') as string},
        {key: 'individualPromoType', label: this.$t('salesMonitorTab.tables.detailColumns.individualPromoType') as string},
        {key: 'individualPromoLift', label: this.$t('salesMonitorTab.tables.detailColumns.individualPromoLift') as string},
        {key: 'basePrice', label: this.$t('salesMonitorTab.tables.detailColumns.basePrice') as string},
        {key: 'vatPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.vatPercentage') as string},
        {key: 'markupPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.markupPercentage') as string},
        {key: 'limitRetailPrice', label: this.$t('salesMonitorTab.tables.detailColumns.limitRetailPrice') as string},
        {key: 'logisticCostsAmount', label: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsAmount') as string},
        {key: 'logisticCostsPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsPercentage') as string},
    ]

    tabs: BTabs | null = null;
    defaultFilterValue = {value: -1, label: this.$t('salesMonitorTab.tables.baseFilters.all') as string};

    selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
    traidingsFilterOptions: Array<SelectBox<number>> = [];

    selectCategoryFilter: SelectBox<number> = this.defaultFilterValue;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: SelectBox<number> = this.defaultFilterValue;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: SelectBox<number> = this.defaultFilterValue;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: SelectBox<number> = this.defaultFilterValue;
    formatFilterOptions: Array<SelectBox<number>> = [];

    selectRegionFilter: SelectBox<number> = this.defaultFilterValue;
    regionFilterOptions: Array<SelectBox<number>> = [];

    selectClusterFilter: SelectBox<number> = this.defaultFilterValue;
    clusterFilterOptions: Array<SelectBox<number>> = [];

    eventPeriodicityOpts = [eventPeriodicityType.DAY, eventPeriodicityType.MONTH, eventPeriodicityType.WEEK]
    eventTypeOpts = eventTypeOptions
    eventChangingTypeOpts = [eventChangingTypeType.BOTH, eventChangingTypeType.DECREASE, eventChangingTypeType.INCREASE]

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('salesMonitorTab.tables.baseFilters.all') as string}];
    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };
    errors = [];
    tableKey = 1;
    searchable: boolean = true;
    selectPeriodicityOptions: SelectBox<LoadEventPeriods> = {value: LoadEventPeriods.DAY, label: this.$t('salesMonitorTab.tables.periods.day') as string};
    selectTypeOptions: SelectBox<LoadEventType> = {
        value: LoadEventTypeValues.CHANGING_PURCHASE_PRICE,
        label: LoadEventTypeLabels.CHANGING_PURCHASE_PRICE,
    };
    changingType: SelectBox<LoadEventChangingType> = {value: LoadEventChangingType.INCREASE, label: this.$t('salesMonitorTab.tables.changingType.increase') as string};

    eventTableRows: SmallEventFilter[] = [];

    delta: number = 1;

    eventTableFields: TableHeaders[] = [
        {key: 'options', label: this.$t('salesMonitorTab.tables.eventsTable.options') as string},
        {key: 'startDate', label: this.$t('salesMonitorTab.tables.eventsTable.startDate') as string},
        {key: 'endDate', label: this.$t('salesMonitorTab.tables.eventsTable.endDate') as string},
        {key: 'periodicity', label: this.$t('salesMonitorTab.tables.eventsTable.periodicity') as string},
        {key: 'type.label', label: this.$t('salesMonitorTab.tables.eventsTable.type') as string},
        {key: 'delta', label: this.$t('salesMonitorTab.tables.eventsTable.delta') as string},
        {key: 'changingType', label: this.$t('salesMonitorTab.tables.eventsTable.changingType') as string},
        {key: 'startCalculation', label: this.$t('salesMonitorTab.tables.eventsTable.startCalculation') as string},
        {key: 'deployPrices', label: this.$t('salesMonitorTab.tables.eventsTable.deployPrices') as string},
        {key: 'createCommonReport', label: this.$t('salesMonitorTab.tables.eventsTable.createCommonReport') as string},
        {key: 'timeout', label: this.$t('salesMonitorTab.tables.eventsTable.timeout') as string},
        {key: 'priority', label: this.$t('salesMonitorTab.tables.eventsTable.priority') as string},
        {key: 'tradingName', label: this.$t('salesMonitorTab.tables.eventsTable.tradingName') as string},
        {key: 'groupsOfProduct', label: this.$t('salesMonitorTab.tables.eventsTable.groupsOfProduct') as string},
        {key: 'categories', label: this.$t('salesMonitorTab.tables.eventsTable.categories') as string},
        {key: 'subcategories', label: this.$t('salesMonitorTab.tables.eventsTable.subcategories') as string},
        {key: 'storeFormat', label: this.$t('salesMonitorTab.tables.eventsTable.storeFormat') as string},
        {key: 'storeRegions', label: this.$t('salesMonitorTab.tables.eventsTable.storeRegions') as string},
        {key: 'storeCluster', label: this.$t('salesMonitorTab.tables.eventsTable.storeCluster') as string},
    ];

    updateInterval: number = 0;
    paramsRulesKey: number = 1;
    eventPerPage: number = 20;
    eventCurrentPage: number = 1;
    eventTotalRows: number = 0;
    calcWithEventCrossForModal: boolean = false;
    showBookmarks: boolean = true;
    showMainFilters: boolean = false;
    hints: Hints[] = [];
    private hasUnsavedRegularPrices: boolean = false;
    private hasUnsavedPromoPrices: boolean = false;
    private refreshEventListId = -1;
    private canBeShowTypes = [TaskType.PACKAGE_GENERAL_SALES];

    getLabel(array: any[], key: string) {
        return array.find((item:any) => key === item.key).label
    }

    fetchTaskHeadersAndKeyIndicators() {
        const params: TaskHeadersAndKeyIndicatorsParams = {
            tradingId: this.salesMonitorData.selectMarket.id,
            categories: LocalData.filterNumberArrays(this.salesMonitorData.categoriesOfProduct),
            groupsOfProduct: this.salesMonitorData.groupsOfProduct,
            subcategories: this.salesMonitorData.subcategories,
            storeFormat: this.salesMonitorData.formatSelected,
            storeRegionValues: this.salesMonitorData.regionIds.realValuesOrEmpty(),
            storeCluster: this.salesMonitorData.clusterIds.realValuesOrEmpty(),
            categoryStrategy: this.salesMonitorData.categoryStrategy.value,
            separateSubcategories: this.salesMonitorData.separateSubcategories,
            separateClusters: this.salesMonitorData.separateClusters,
            storeSegment: this.salesMonitorData.buyerSegmentsList,
            timeout: this.salesMonitorData.timeout,
            priority: this.salesMonitorData.priority,
            limit: this.pagination.pageSize,
            offset: (this.pagination.current - 1) * this.pagination.pageSize,
            dateBefore: this.dateRange[0],
            dateAfter: this.dateRange[1],
            status: this.currentTabStatus,
            types: [TaskType.PACKAGE_GENERAL_SALES],
        }

        this.priorityResponseLevel += 1;

        this.isTableLoading = true;

        this.httpGetSaleAllUserTasksHeaders(params)
                .then((r) => {
                    if (!this.ignorePrevResponse || this.priorityResponseLevel > 1) {
                        this.resultGeneralSubtasksTableHeaders = r.data.resultTableHeaders;
                        this.tableData = r.data.resultTableHeaders;
                        this.pagination.total = r.data.totalRows;

                        if (this.pagination.total === 0) {
                            this.resultTableHeaders = [];
                        }

                        this.getAllTasksKeyIndicators(params)
                            .then((res) => {
                                    this.resultTableHeaders = [];
                                    this.resultTableHeaders = res.data;
                                },
                            )
                            .catch((e) => {
                                this.showOverlay = false;
                            });

                        this.$log.info(r.data);
                    } else {
                        this.ignorePrevResponse = false;
                    }
                })
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadReports') as string)
                }).finally(() => {
                    this.priorityResponseLevel -= 1;

                    this.isTableLoading = false;
                    if (this.isApplyRangeBtnLoading) this.isApplyRangeBtnLoading = false;
                    if (this.isApplyFiltersBtnLoading) this.isApplyFiltersBtnLoading = false;

                    this.dataCardsKey += 1;
                });
    }

    applyClick(type: string) {
        this.pagination.current = 1;
        this.pagination.pageSize = 10;
        this.pagination.total = 0;

        if (type === 'dateRange') this.isApplyRangeBtnLoading = true;
        if (type === 'filters') this.isApplyFiltersBtnLoading = true;

        if (this.priorityResponseLevel) {
            this.ignorePrevResponse = true;
        }

        this.fetchTaskHeadersAndKeyIndicators();
    }

    startMonitorUpdate() {
        const updateFrequency = parseInt(localStorage.getItem('updateFrequency') || '0', 10);

        this.updateInterval = setInterval(() => {
            this.fetchTaskHeadersAndKeyIndicators();
        }, updateFrequency * 60000);

        this.fetchTaskHeadersAndKeyIndicators();
    }

    stopMonitorUpdate() {
        clearInterval(this.updateInterval);
    }

    inputTaskNote(taskNoteParam: string, taskId: number) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            const taskParam: TaskNoteDTO = {
                taskNote: taskNoteParam,
            }
            this.httpCreateNote(taskId, taskParam);
        }, 500);
    }

    mounted() {
        this.tabs = this.$refs.mainTabs as BTabs;

        EventBus.$on('calc', this.onTaskEventReceived);
        EventBus.$on('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
    }

    beforeDestroy() {
        this.stopMonitorUpdate();
        this.resultTableHeaders = [];

        EventBus.$off('calc', this.onTaskEventReceived)
        EventBus.$off('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
    }

    created() {
        this.salesMonitorData = {
            defaultSelectValue: [{value: 0, label: this.$t('salesMonitorTab.tables.baseFilters.all') as string}],
            categoriesOfProduct: [],
            allCheck: true,
            groupsOfProduct: [],
            buyerSegmentsList: [],
            seasonSelected: [],
            formatSelected: [],
            regionIds: [],
            clusterIds: [],
            selectMarket: {id: -1, tradingName: this.$t('salesMonitorTab.messages.selectPlaceholder') as string, isDefault: false},
            subcategories: [],
            separateSubcategories: false,
            separateClusters: true,
            startCalculation: false,
            onlyChangedPrices: true,
            createCommonReport: false,
            deployPrices: false,
            periodicity: eventPeriodicityType.DAY,
            type: eventTypeLoadType.CHANGING_PURCHASE_PRICE,
            changingType: eventChangingTypeType.INCREASE,
            categoryStrategy: categoryStrategiesSet.EMPTY,
            timeout: 24,
            priority: 1,
            storeSegment: [],
            productSegments: [],
            applyOmnichannel: false,
            groupOfProduct: null,
            categoryOfProduct: null,
            singleFormat: null,
            singleRegion: null,
            selectKviCart: null,
        };
    }

    onTableChange(pagination: {current: number, pageSize: number}) {
        this.stopMonitorUpdate();

        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;

        this.startMonitorUpdate();
    }

    refreshEventList() {
        const oldRefreshId = this.refreshEventListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshEventListId === timeoutId) {
                this.eventCurrentPage = 1;
                const events = this.$refs.eventTableRef as any;
                if (typeof events !== 'undefined') {
                    events.refresh();
                }
                this.refreshEventListId = -1;
            }
        }, 250);
        this.refreshEventListId = timeoutId;
    }

    isDateRangeValid(dateRange: string[]) {
        return dateRange.length === 2 && moment(dateRange[0]).isValid() && moment(dateRange[1]).isValid()
    }

    changeDateRange(dateRange: string[]) {
        this.dateRange = dateRange;

        if (this.isDateRangeValid(dateRange)) {
            if (this.isRangeNotSelected) this.isRangeNotSelected = false;
            localStorage.setItem('resultsMonitorDate', JSON.stringify(dateRange));
        } else {
            this.isRangeNotSelected = true;
            localStorage.removeItem('resultsMonitorDate');
        }
    }

    showDownloadButton(task: TaskData): boolean {
        const restrictedStatuses = [
            TaskStatus.CALCULATING,
            TaskStatus.CALCULATING_COMPLETE,
            TaskStatus.WRITETOFILE
        ].map((v) => v.valueOf())

        return !!task.fileResult.length
            && !task.needRecalculatePackageTask
            && !(restrictedStatuses.includes(task.status))
    }

    showStopButton(task: TaskData): boolean {
        return task.typeMachine === TaskType.BRUT_FORCE && task.status === TaskStatus.CALCULATING
    }

    stopBrutForcing(taskId: number) {
        this.httpExecutor.executeHttp(this.httpStopBrutForce, taskId)
            .then((r) => {
                if (!r.ignore) {
                    const resp = r.response;
                    if (resp.status === 204) {
                        this.showInfo(this.$t('salesMonitorTab.messages.infoParamsStopped') as string)
                    } else if (resp.status === 404) {
                        this.showInfo(this.$t('salesMonitorTab.messages.infoParamsNotFound') as string)
                    } else {
                        this.showError(this.$t('salesMonitorTab.messages.errorStopParams') as string)
                    }
                }
            })
            .catch((e) => {
                this.showError(this.$t('salesMonitorTab.messages.errorStopParams') as string)
            })
    }

    recalculateGeneralTask(generalTaskId: number) {
        this.httpRecalculateGeneralTask(generalTaskId)
            .then((result) => {
                this.showInfo((this.$t('salesMonitorTab.messages.infoRecalculate', {id: generalTaskId}) as string));
                // this.handleFilter();

            })
            .catch(() => {
                this.showError(this.$t('salesMonitorTab.messages.errorRecalculate') as string);
            });
    }

    showGenerateReportButton(task: TaskData): boolean {
        const isTaskReadyToBeGenerated = isTaskInBackgroundGeneratableTypesAndStatuses(task.type as TaskType, task.status);

        return !task.fileResult.length && isTaskReadyToBeGenerated && !task.needRecalculatePackageTask;
    }

    generateReport(task: TaskData) {
        this.httpStartGeneratingReport(task.taskId)
            .then(() => {
                task.status = TaskStatus.WRITETOFILE
            })
    }

    canBeShown(task: TaskData): boolean {
        const found = this.canBeShowTypes.findIndex((type) => task.type as TaskType === type)
        if (found === -1) {
            return false;
        }
        return !task.needRecalculatePackageTask && (task.status === 'WriteToFileComplete' || task.status === 'OnApproval' || task.status === 'Rejected' || task.status === 'Approved');
    }

    showSaveFinalReportButton(task: TaskData): boolean {
        return task.status == TaskStatus.APPROVED && !!task.fileForRevaluationResult
    }

    showSetDefaultParamButton(task: TaskData): boolean {
        const restrictedTaskTypes = [
            TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS,
            TaskType.SEARCH_KVI,
            TaskType.PACKAGE_GENERAL,
            TaskType.PACKAGE_GENERAL_SCENARIO,
            TaskType.PACKAGE_EVENTS_GENERAL,
        ]

        const isPackageTaskReadyToBeGenerated =
            isTaskInBackgroundGeneratableTypesAndStatuses(task.type as TaskType, task.status)

        return !task.needRecalculatePackageTask
            && !restrictedTaskTypes.includes(task.type as TaskType)
            && (task.fileResult.length > 0 || isPackageTaskReadyToBeGenerated)
    }

    getDateRange(): string {
        const dateRange = localStorage.getItem('resultsMonitorDate');
        return dateRange !== null && this.isDateRangeValid(JSON.parse(dateRange) as string[]) ? dateRange : '';
    }

    resetData(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.salesMonitorData.categoriesOfProduct = [];
                this.salesMonitorData.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.salesMonitorData.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.categoryOptions = [];
                this.taskInfo.subcategories = [];
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.getCategoryInfo(null);
                this.loadProductsSubcategories();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.category:
                this.salesMonitorData.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.salesMonitorData.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.subcategories = [];
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.loadProductsSubcategories();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.subcategory:
                this.salesMonitorData.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.salesMonitorData.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.format:
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.region:
                this.taskInfo.clusterOptions = [];
                this.getClusterInfo();
                break;
        }
    }

    updateProductGroup(groupOfProduct: number[]) {
        if (groupOfProduct.length > 0 && !LocalData.compareTwoArrays(groupOfProduct, this.salesMonitorData.groupsOfProduct)) {
            this.salesMonitorData.groupsOfProduct = groupOfProduct;
            this.saveEvents();
            this.resetData(TaskInfoFilterType.group);
        } else if (this.salesMonitorData.groupsOfProduct[0] === 0) {
            this.salesMonitorData.groupsOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateProductCategory(categories: number[]) {
        if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.salesMonitorData.categoriesOfProduct)) {
            this.salesMonitorData.categoriesOfProduct = categories;
            this.resetData(TaskInfoFilterType.category);
            this.saveEvents();
        } else if (this.salesMonitorData.categoriesOfProduct[0] === 0) {
            this.salesMonitorData.categoriesOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateFormats(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.salesMonitorData.formatSelected)) {
            this.salesMonitorData.formatSelected = list;
            this.resetData(TaskInfoFilterType.format);
            this.saveEvents();
        } else if (this.salesMonitorData.formatSelected[0] === 0) {
            this.salesMonitorData.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.salesMonitorData.regionIds)) {
            this.salesMonitorData.regionIds = list;
            this.resetData(TaskInfoFilterType.region);
            this.saveEvents();
        } else if (this.salesMonitorData.regionIds[0] === 0) {
            this.salesMonitorData.regionIds = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateClusters(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.salesMonitorData.clusterIds)) {
            this.salesMonitorData.clusterIds = list;
            this.resetData(TaskInfoFilterType.cluster);
            this.saveEvents();
        } else if (this.salesMonitorData.clusterIds[0] === 0) {
            this.salesMonitorData.clusterIds = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.salesMonitorData.subcategories)) {
            this.salesMonitorData.subcategories = list;
            this.saveEvents();
            this.resetData(TaskInfoFilterType.subcategory);
        } else if (this.salesMonitorData.subcategories[0] === 0) {
            this.salesMonitorData.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    selectData(): [number[], number[], number[], number[]] {
        const selectSeasons: number[] = (this.salesMonitorData.seasonSelected.length === 0 || (this.salesMonitorData.seasonSelected.length === 1 && this.salesMonitorData.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.salesMonitorData.seasonSelected)!!;
        const selectRegions: number[] = (this.salesMonitorData.regionIds.length === 0 || (this.salesMonitorData.regionIds.length && this.salesMonitorData.regionIds[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.salesMonitorData.regionIds)!!;
        const selectBuyerSegment: number[] = (this.salesMonitorData.buyerSegmentsList.length === 0 || (this.salesMonitorData.buyerSegmentsList.length && this.salesMonitorData.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.salesMonitorData.buyerSegmentsList)!!;
        const selectFormats: number[] = (this.salesMonitorData.formatSelected.length === 0 || (this.salesMonitorData.formatSelected.length && this.salesMonitorData.formatSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.salesMonitorData.formatSelected)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    loadProductsGroup() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.groupOfProductRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.groupsOfProduct.unshift({value: 0, label: this.$t('salesMonitorTab.tables.baseFilters.all') as string});
                })
                .catch((e) => {
                })
    }

    loadProductsSubcategories() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.subcategoriesRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.subcategories.unshift({value: 0, label: this.$t('salesMonitorTab.tables.baseFilters.all') as string})
                })
                .catch((e) => {
                })
    }

    getCategoryInfo(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.groupSelectedRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.categoryOptions.unshift();
                    if (typeof cb === 'function') {
                        cb();
                    }
                })
                .catch((e) => {
                })
    }

    getRegionInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateRegionsRef as any).toggleLoading(false);

                    }, 500);

                    this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });
    }

    getFormatInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.formatSelectedRef as any).toggleLoading(false);
                    }, 500);
                    this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name};
                    });

                })
                .catch((e) => {
                });
    }

    getClusterInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });
    }

    thAttrTitle(value: any, key: any, item: any, type: any) {
        const fieldDef = this.resultDetailFields.find((value, index) => value.key === key);

        if (fieldDef != null) {
            return {title: fieldDef.label}
        } else {
            return {}
        }
    }

    beforeDeleteFileDialog(taskId: number) {
        this.showDeleteSingleReportModal = true
        this.taskIdForDelete = taskId;
    }

    showDeleteFileDialog(taskId: number) {
        this.deleteTask([taskId]);
        location.reload()
    }

    deleteTask(taskIds: number[]) {
        this.$http.post('/api/task/delete', taskIds)
                .then(() => {
                    (this.$refs.resultGeneralSubReportsRef as any).refresh();
                })
                .catch(() => {
                    this.showError(this.$t('salesMonitorTab.messages.errorDeleteReport') as string);
                });
    }

    selectResult(task: TaskData) {
        this.$router.push(`/reports/${task.taskId}`)
        let subCategories = ' - ';
        if (task.subcategories.length > 0) {
            subCategories = task.subcategories + ' / '
        }
        let formatName = ' - ';
        if (task.format !== '') {
            formatName = task.format + ' / '
        }

        let regionName = ' - ';
        if (task.region !== '') {
            regionName = task.region + ' / '
        }

        let clusterName = ' - ';
        if (task.cluster !== '') {
            clusterName = task.cluster + ' / '
        }
        const filters = task.group + ' / ' + task.category + ' / ' + subCategories + formatName + regionName + clusterName
        this.taskToView = {
            id: task.id,
            status: task.status,
            type: task.typeMachine,
            fileResult: task.fileResult,
            editable: task.editable,
            filterNames: filters,
        };
        (this.$refs.resultViewTab as any).disabled = false;
        (this.$refs.resultViewTab as any).activate();
    }

    clearCalcAllData() {
        this.clearDetailTableFilter();
        this.pagination.total = 0;
        this.segmentPriceOptionsForDetailTable = [];
        this.isDownloadAllFiltersName = false
        this.resultTableDetailReports = [];
        this.tableKey = Math.random();
        this.changesPrices = [];
        this.hasUnsavedRegularPrices = false;
        this.isGeneralRegularPackage = false;
        this.showGeneralComparableBlock = true;
    }

    clearPromoAllData() {
        this.clearDetailTableFilter();
        this.pagination.total = 0;
        this.segmentPriceOptionsForDetailTable = [];
        this.isDownloadAllFiltersName = false
        this.resultTableDetailReports = [];
        this.tableKey = Math.random();
        this.changesPrices = [];
        this.hasUnsavedPromoPrices = false;
        this.isGeneralRegularPackage = false;
        this.showGeneralComparableBlock = true;
    }

    moveFiltersToTableFilters(taskId: number) {
        this.showAction(
                this.$t('salesMonitorTab.messages.confirmSetDefaults') as string,
                {
                    position: 'top-center',
                    type: 'info',
                    singleton: true,
                    duration: 10000,
                    icon: 'filter',
                    theme: 'bubble',
                    action: [{
                        text: this.$t('salesMonitorTab.modals.yes') as string,
                        onClick: () => {
                            const taskIds: number[] = []
                            taskIds.push(taskId)
                            this.httpMoveTaskFilter(taskIds)
                                    .then(() => {
                                        this.showInfo(this.$t('salesMonitorTab.messages.successSetDefaults') as string);

                                    })
                                    .catch(() => {
                                        this.showError(this.$t('salesMonitorTab.messages.errorSetFilter', {id: taskId}) as string);
                                    });
                        }
                    }]
                });
    }

    beforeSendToFTPDialog(taskId: number) {
        this.sendFileToFtpServer(taskId)
    }

    beforeSendToFTPDialogForSubTask(taskId: number) {
        this.showSendToFTPSubTaskReportModal = true
        this.subTaskIdForSendToFTP = taskId;
    }

    showDeleteTaskButton(task: ResultTableHeaders): boolean {
      return task.status != TaskStatus.APPROVED
    }

    showDownloadPriceButton(task: ResultTableHeaders): boolean {
      return task.status !== TaskStatus.APPROVED
          && task.status !== TaskStatus.ONAPPROVAL
          && taskTypesRequiresConfirmation.map((entry) => entry.value).includes(task.type)
    }

    onFtpDownloadProgressReceived(ftpSendProgress: FtpDownloadProgress) {
        this.updateSendToFtpProgress(ftpSendProgress);
    }

    updateSendToFtpProgress(ftpSendProgress: FtpDownloadProgress) {
        const index = this.resultGeneralSubtasksTableHeaders.findIndex((item) => {
            return item.taskId === ftpSendProgress.taskId;
        });
        if (index !== -1) {
            this.resultGeneralSubtasksTableHeaders[index].ftpSendingStatus = ftpSendProgress.ftpSendStatus;
        }
    }

    getReportDetailFieldsByUserId() {
        this.httpGetReportDetailFieldsByUserId(this.isPromo ? 'promo' : 'regular')
                .then((r) => {
                            this.detailUserFields = r.data;
                            if (this.detailUserFields.length !== 0) {
                                if (this.isPromo) {
                                    this.detailUserFields.forEach((detailField) => {
                                        // tslint:disable-next-line: no-non-null-assertion
                                        const reportField = this.allDetailReportFields.find((v) => v.key === detailField.key)
                                        if (reportField == null) {
                                            this.$log.debug('notFound', detailField.key);
                                        } else {
                                            this.promoDetailReport.push({
                                                key: detailField.key,
                                                label: reportField.label,
                                                sortable: true,
                                                thClass: ['croppedText'],
                                                thAttr: {title: reportField.label}
                                            })
                                        }
                                    });
                                } else {
                                    this.detailUserFields.forEach((detailField) => {
                                        // tslint:disable-next-line: no-non-null-assertion
                                        const reportField = this.allDetailReportFields.find((v) => v.key === detailField.key)!!
                                        this.regularDetailReport.push({
                                            key: detailField.key,
                                            label: reportField.label,
                                            sortable: true,
                                            thClass: ['croppedText'],
                                            thAttr: {title: reportField.label}
                                        })
                                    });
                                }
                            }
                        },
                )
                .catch((e) => {
                    this.$log.error(e)
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadDetailFields') as string);
                });
    }

    onTaskEventReceived(task: TaskData) {
        if (this.taskData != null && this.taskData.id === task.id) {
            this.taskData.status = task.status;
            if (this.taskData.status === 'WriteToFileComplete' || this.taskData.status === 'OnApproval' || this.taskData.status === 'Rejected' || this.taskData.status === 'Approved') {
                this.changesPrices = [];
                this.hasUnsavedRegularPrices = false;
                this.hasUnsavedPromoPrices = false;


                this.hideActiveStatusMessage();
            }
        }
    }

    @Watch('selectMarketProp', {deep: true})
    updateSelectMarket(market: SelectMarket) {
        if (market && market.id && market.id !== -1) {
            this.salesMonitorData.selectMarket = market;

            (this.$refs.groupSelectedRef as any).toggleLoading(true);
            (this.$refs.updateRegionsRef as any).toggleLoading(true);
            (this.$refs.formatSelectedRef as any).toggleLoading(true);
            (this.$refs.clasterSelectedRef as any).toggleLoading(true);
            (this.$refs.groupOfProductRef as any).toggleLoading(true);
            (this.$refs.subcategoriesRef as any).toggleLoading(true);
            this.getCategoryInfo();
            this.getRegionInfo();
            this.getFormatInfo();
            this.getClusterInfo();
            this.loadProductsGroup();
            this.loadProductsSubcategories();

            this.startMonitorUpdate();
        }
    }

    @Watch('taskData')
    onTaskDataChanged(taskData: TaskAndFile | null, oldValue: TaskAndFile | null) {
        if (taskData == null) {
            this.clearCalcAllData();
            this.clearPromoAllData();
        } else {
            if (taskData.status !== 'WriteToFileComplete' && taskData.status !== 'OnApproval' && taskData.status !== 'Rejected' && taskData.status !== 'Approved') {
                this.showActiveStatusMessage();
                return;
            }
            if (oldValue == null || taskData.id !== oldValue.id) {
                this.isPromo = taskData.type === TaskType.PROMO || taskData.type === TaskType.PACKAGE_PROMO || taskData.type === TaskType.PACKAGE_GENERAL_PROMO;
                this.isPackageOrScheduleReport = taskData.type === TaskType.PACKAGE_REGULAR || taskData.type === TaskType.PACKAGE_SCHEDULE || taskData.type === TaskType.PACKAGE_SCENARIO || taskData.type === TaskType.PACKAGE_EVENTS || taskData.type === TaskType.SCHEDULED_PRICE_EXP;
                this.isPackagePromoReport = taskData.type === TaskType.PACKAGE_PROMO;
                if (this.isPromo) {
                    this.detailTableIdName = 'resultDetailPromoReport'
                }
                this.isPromo ? this.clearPromoAllData() : this.clearCalcAllData()
                if (taskData.type === TaskType.PACKAGE_GENERAL || taskData.type === TaskType.PACKAGE_GENERAL_SCENARIO || taskData.type === TaskType.PACKAGE_EVENTS_GENERAL) {
                    this.isGeneralRegularPackage = true
                    this.showGeneralComparableBlock = false
                }
                this.loadHeaders();
                this.loadDetails();
                this.getReportDetailFieldsByUserId();
                this.tryFindParams(taskData.id);
            }
        }
    }

    tryFindParams(taskId: number) {
        if (this.isPackageOrScheduleReport || this.isPackagePromoReport) {
            this.loadPackageCommonParams(taskId);
            if (this.isPackagePromoReport) {
                this.loadPackagePromoParams(taskId);
            }
        }
    }

    loadPackageCommonParams(taskId: number) {
        this.httpFindPackageBaseParams(taskId)
                .then((r) => {
                            this.applyPackageParamsInDetailReportCalcFilters(this.$packageParamsInDetailReport, r.data);
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadPackageParams') as string);
                    this.$log.error('Error occurred [load package base filters]', e);
                });
    }

    loadPackagePromoParams(taskId: number) {
        this.httpFindPackagePromoParams(taskId)
                .then((r) => {
                            this.applyPackageParamsInDetailReportPromoFilters(this.$packageParamsInDetailReport, r.data);
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadPackagePromoParams') as string);
                    this.$log.error('Error occurred [load package promo filters]', e);
                });
    }

    showActiveStatusMessage() {
        (this.$refs['statusModal'] as BModal).show();
    }

    hideActiveStatusMessage() {
        (this.$refs['statusModal'] as BModal).hide();
    }

    downloadFileInPackageSubTask(taskId: number, file: string) {
        this.$http.get('/api/task/result', {
            method: 'GET',
            responseType: 'blob',
            params: {
                taskId,
            },
        })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorDownloadReport') as string);
                });
    }

    downloadFinalReportFile(item: ResultTableHeaders) {
      this.httpDownloadFinalReportFile(item.taskId, item.fileForRevaluationResult)
    }

    sendFileToFtpServer(taskId: number) {
        this.httpSendReportToFtpServer([taskId])
            .then((r) => {
                this.showInfo(this.$t('salesMonitorTab.messages.infoSendForApproval') as string);
            })
            .catch((e) => {
                this.showError(this.$t('salesMonitorTab.messages.errorSendForApproval', {reason: e.response.data}) as string);
            });
    }

    sendSubTaskToFtpServer(taskId: number) {
        this.httpSendReportToFtpServer([taskId])
                .then((r) => {
                    this.showInfo(this.$t('salesMonitorTab.messages.infoSendForApproval') as string);
                })
                .catch((exception) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorSendForApproval', {reason: exception.response.data.message}) as string);
                });
        location.reload()
    }

    changeTab(tabKey: string) {
        this.stopMonitorUpdate();

        if (tabKey !== 'ganttDiagram') {
            switch (tabKey) {
                case "changeNotAgreed":
                    this.currentTabStatus = 'NOT_AGREED';
                    break;
                case "changeRequireAttention":
                    this.currentTabStatus = 'REQUIRES_ATTENTION';
                    break;
                case "changeApproved":
                    this.currentTabStatus = 'APPROVED';
                    break;
                default:
                    this.currentTabStatus = 'DEFAULT';
                    break;
            }

            this.pagination.current = 1;
            this.pagination.pageSize = 10;
            this.pagination.total = 0;

            if (this.priorityResponseLevel) {
                this.ignorePrevResponse = true;
            }

            this.startMonitorUpdate();
        }
    }

    resetAllSortingFields() {
        this.sortByTaskId = -1;
        this.sortByGroupName = -1;
        this.sortByCategoryName = -1;
        this.sortBySubCategoryName = -1;
        this.sortByFormatName = -1;
        this.sortByRegionName = -1;
        this.sortByClusterName = -1;
        this.sortByProductSegmentName = -1;
        this.sortByInternalCode = -1;
        this.sortBySkuName = -1;
        this.sortByEventTrigger = -1;
        this.sortByKvi = -1;
        this.sortByCtm = -1;
        this.sortByCtmBrand = -1;
        this.sortByCtmPriceGap = -1;
        this.sortByMinRetailPrice = -1;
        this.sortByMaxRetailPrice = -1;
        this.sortByKeyProduct1 = -1;
        this.sortByKeyProduct2 = -1;
        this.sortByRecipeAttribute = -1;
        this.sortByTreatmentAttribute = -1;
        this.sortByVitalMedicine = -1;
        this.sortByProducerPrice = -1;
        this.sortByExtraChargePc = -1;
        this.sortByRegistrationPrice = -1;
        this.sortBySegment = -1;
        this.sortBySkuLine = -1;
        this.sortByPurchasePrice = -1;
        this.sortByPromoPurchasePrice = -1;
        this.sortByAvgRegularPrice = -1;
        this.sortByAvgCashPrice = -1;
        this.sortByAvgCheckPrice = -1;
        this.sortByRegularPrice = -1;
        this.sortByMarginLastPrice = -1;
        this.sortByMinCompetitorPrice = -1;
        this.sortByMinCompetitorName = -1;
        this.sortByMaxCompetitorPrice = -1;
        this.sortByMaxCompetitorName = -1;
        this.sortByAvgCompetitorPrice = -1;
        this.sortByLastCompetitorPrice = -1;
        this.sortByMinPromoCompetitorPrice = -1;
        this.sortByMinPromoCompetitorName = -1;
        this.sortByMaxPromoCompetitorPrice = -1;
        this.sortByMaxPromoCompetitorName = -1;
        this.sortByMedianPromoCompetitorPrice = -1;
        this.sortByLastPromoCompetitorPrice = -1;
        this.sortByPi = -1;
        this.sortByActualSales = -1;
        this.sortByActualRevenue = -1;
        this.sortByActualMargin = -1;
        this.sortByActualMarginPercent = -1;
        this.sortByComparableSales = -1;
        this.sortByComparableRevenue = -1;
        this.sortByComparableMargin = -1;
        this.sortByComparableMarginPc = -1;
        this.sortByNewPrice = -1;
        this.sortByNewPromoPrice = -1;
        this.sortByCorrectedPromoPrice = -1;
        this.sortByCorrectedRegularPrice = -1;
        this.sortByNewMarginPc = -1;
        this.sortByNewPI = -1;
        this.sortByDeltaDiffPrice = -1;
        this.sortByPriceDiffPc = -1;
        this.sortByMarginDiff = -1;
        this.sortByChangedPI = -1;
        this.sortByDiscountDepth = -1;
        this.sortByDiscountDuration = -1;
        this.sortByExitSegment = -1;
        this.sortByCoeffElasticity = -1;
        this.sortByPromoCoeffElasticity = -1;
        this.sortBySalesForecast = -1;
        this.sortByRevenueForecast = -1;
        this.sortByMarginForecast = -1;
        this.sortByMarginForecastPc = -1;
        this.sortByChangeSales = -1;
        this.sortByChangeRevenue = -1;
        this.sortByChangeMargin = -1;
        this.sortBySalesDiffPc = -1;
        this.sortByRevenueDiffPc = -1;
        this.sortByMarginDiffPc = -1;
        this.sortByMarginDiffSecond = -1;
        this.sortBySalesForecastByRegularPrice = -1;
        this.sortByRevenueForecastByRegularPrice = -1;
        this.sortByMarginForecastByRegularPrice = -1;
        this.sortByMarginForecastByRegularPricePc = -1;
        this.sortByChangeSalesByRegularPrice = -1;
        this.sortByChangeRevenueByRegularPrice = -1;
        this.sortByChangeMarginByRegularPrice = -1;
        this.sortBySalesDiffPcByRegularPrice = -1;
        this.sortByRevenueDiffPcByRegularPrice = -1;
        this.sortByMarginDiffPcByRegularPrice = -1;
        this.sortByMarginDiffSecondByRegularPrice = -1;
        this.sortByIndividualPriceOptStrategy = -1;
        this.sortByIndividualPriceIncreaseLimit = -1;
        this.sortByIndividualPeriodPriceIncreaseLimit = -1;
        this.sortByIndividualPeriod = -1;
        this.sortByIndividualMarginalProfit = -1;
        this.sortByIndividualKviStrategy = -1;
        this.sortByIndividualPercentCorrection = -1;
        this.sortByIndividualNewProductPriceStrategy = -1;
        this.sortByIndividualPriceGapPercent = -1;
        this.sortByIndividualPromoType = -1;
        this.sortByIndividualPromoLift = -1;
    }

    resetAllFiltersFields() {
        this.selectTaskIdForDetailTable = []
        this.selectMessageForDetailTable = []
        this.selectGroupNameForDetailTable = []
        this.selectCategoryNameForDetailTable = []
        this.selectSubcategoryNamesForDetailTable = []
        this.selectFormatNameForDetailTable = []
        this.selectRegionNameForDetailTable = []
        this.selectClusterNameForDetailTable = []
        this.selectSegmentNameForDetailTable = []
        this.selectInternalCodeForDetailTable = []
        this.selectSkuNameForDetailTable = []
        this.selectCtmBrandForDetailTable = []
        this.selectCtmPriceGapForDetailTable = []
        this.selectMinRetailPriceForDetailTable = []
        this.selectMaxRetailPriceForDetailTable = []
        this.selectKeyProduct1ForDetailTable = []
        this.selectKeyProduct2ForDetailTable = []
        this.selectRecipeAttributeForDetailTable = []
        this.selectTreatmentAttributeForDetailTable = []
        this.selectProducerPriceForDetailTable = []
        this.selectExtraChargePcForDetailTable = []
        this.selectRegistrationPriceForDetailTable = []
        this.selectSegmentPriceForDetailTable = []
        this.selectSkuLineForDetailTable = []
        this.selectPurchasePriceForDetailTable = []
        this.selectPromoPurchasePriceForDetailTable = []
        this.selectAvgRegularPriceForDetailTable = []
        this.selectAvgCashPriceForDetailTable = []
        this.selectAvgCheckPriceForDetailTable = []
        this.selectRegularPriceForDetailTable = []
        this.selectMarginLastPriceForDetailTable = []
        this.selectMinCompetitorPriceForDetailTable = []
        this.selectMinCompetitorNameForDetailTable = []
        this.selectMaxCompetitorPriceForDetailTable = []
        this.selectMaxCompetitorNameForDetailTable = []
        this.selectAvgCompetitorPriceForDetailTable = []
        this.selectLastCompetitorPriceForDetailTable = []
        this.selectMinPromoCompetitorPriceForDetailTable = []
        this.selectMinPromoCompetitorNameForDetailTable = []
        this.selectMaxPromoCompetitorPriceForDetailTable = []
        this.selectMaxPromoCompetitorNameForDetailTable = []
        this.selectMedianPromoCompetitorPriceForDetailTable = []
        this.selectLastPromoCompetitorPriceForDetailTable = []
        this.selectPiForDetailTable = []
        this.selectActualSalesForDetailTable = []
        this.selectActualRevenueForDetailTable = []
        this.selectActualMarginForDetailTable = []
        this.selectActualMarginPercentForDetailTable = []
        this.selectComparableSalesForDetailTable = []
        this.selectComparableRevenueForDetailTable = []
        this.selectComparableMarginForDetailTable = []
        this.selectComparableMarginPcForDetailTable = []
        this.selectNewPriceForDetailTable = []
        this.selectNewPromoPriceForDetailTable = []
        this.selectCorrectedRegularPriceForDetailTable = []
        this.selectCorrectedPromoPriceForDetailTable = []
        this.selectNewMarginPcForDetailTable = []
        this.selectNewPIForDetailTable = []
        this.selectDeltaDiffPriceForDetailTable = []
        this.selectPriceDiffPcForDetailTable = []
        this.selectMarginDiffForDetailTable = []
        this.selectChangedPIForDetailTable = []
        this.selectDiscountDepthForDetailTable = []
        this.selectDiscountDurationForDetailTable = []
        this.selectExitSegmentForDetailTable = []
        this.selectCoeffElasticityForDetailTable = []
        this.selectPromoCoeffElasticityForDetailTable = []
        this.selectSalesForecastForDetailTable = []
        this.selectRevenueForecastForDetailTable = []
        this.selectMarginForecastForDetailTable = []
        this.selectMarginForecastPcForDetailTable = []
        this.selectChangeSalesForDetailTable = []
        this.selectChangeRevenueForDetailTable = []
        this.selectChangeMarginForDetailTable = []
        this.selectSalesDiffPcForDetailTable = []
        this.selectRevenueDiffPcForDetailTable = []
        this.selectMarginDiffPcForDetailTable = []
        this.selectMarginDiffSecondForDetailTable = []
        this.selectIndividualPromoTypeForDetailTable = []
        this.selectIndividualPromoLiftForDetailTable = []
        this.selectSalesForecastByRegularPriceForDetailTable = []
        this.selectRevenueForecastByRegularPriceForDetailTable = []
        this.selectMarginForecastByRegularPriceForDetailTable = []
        this.selectMarginForecastByRegularPricePcForDetailTable = []
        this.selectChangeSalesByRegularPriceForDetailTable = []
        this.selectChangeRevenueByRegularPriceForDetailTable = []
        this.selectChangeMarginByRegularPriceForDetailTable = []
        this.selectSalesDiffPcByRegularPriceForDetailTable = []
        this.selectRevenueDiffPcByRegularPriceForDetailTable = []
        this.selectMarginDiffPcByRegularPriceForDetailTable = []
        this.selectMarginDiffSecondByRegularPriceForDetailTable = []
        this.selectIndividualPriceOptStrategyForDetailTable = []
        this.selectIndividualPriceIncreaseLimitForDetailTable = []
        this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = []
        this.selectIndividualPeriodForDetailTable = []
        this.selectIndividualMarginalProfitForDetailTable = []
        this.selectIndividualKviStrategyForDetailTable = []
        this.selectIndividualPercentCorrectionForDetailTable = []
        this.selectIndividualNewProductPriceStrategyForDetailTable = []
        this.selectIndividualPriceGapPercentForDetailTable = []
    }

    private clearDetailTableFilter() {
        this.detailTableSkuFilter = '';
        this.resetAllSortingFields()
        this.resetAllFiltersFields()
    }

    private loadHeaders() {
        this.downloadLastExcelHeaderByFilters = true;
    }

    private loadDetails() {
        this.downloadLastExcelDetailByFilters = true;
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions, , selectFormats] = this.selectData();
        return {
            type: taskType,
            tradingId: this.salesMonitorData.selectMarket.id,
            categories: LocalData.filterNumberArrays(this.salesMonitorData.categoriesOfProduct),
            groups: LocalData.filterNumberArrays(this.salesMonitorData.groupsOfProduct),
            subcategory: LocalData.filterNumberArrays(this.salesMonitorData.subcategories, true),
            segments: null,
            storeFormat: selectFormats,
            storeCluster: this.salesMonitorData.clusterIds.realValuesOrEmpty(),
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    get isGroupsSelected(): boolean {
        const groups = LocalData.filterNumberArrays(this.salesMonitorData.groupsOfProduct);
        return groups != null && groups.length > 0;
    }

    get isCategoriesSelected(): boolean {
        const categories = LocalData.filterNumberArrays(this.salesMonitorData.categoriesOfProduct);
        return categories != null && categories.length > 0;
    }

    get isFormatSelected(): boolean {
        const formats = LocalData.filterNumberArrays(this.salesMonitorData.formatSelected);
        return formats != null && formats.length > 0;
    }

    get isRegionsSelected(): boolean {
        const regions = LocalData.filterNumberArrays(this.salesMonitorData.regionIds.realValuesOrEmpty());
        return regions != null && !!regions.length;
    }

    get resultDetailFields(): TableHeaders[] {
        if (this.isPromo) {
            return this.promoDetailReport;
        } else {
            return this.regularDetailReport;
        }
    }

    get taskId(): string {
        if (this.taskData == null) {
            return '';
        }

        return `${this.taskData.id}`;
    }

    private handleOpenParamsTab(sale: ISale): void {
        this.$emit('open-params-tab', sale, true);
    }

    getSaleTypeLabel(typeValue: string | null = null) {
        const typeObj = this.saleTypeOptions.find(option => option.value === typeValue);

        return typeObj ? typeObj.label : (this.$t('salesMonitorTab.messages.unknownType') as string);
    }
}
